import { Summarize, PeopleAlt, Newspaper, Tag, Dashboard } from '@mui/icons-material';
import { PATHS } from 'src/constants/config';

const toolsItems = [
  {
    title: 'Wins Dashboard',
    description: 'View wins dashboard',
    icon: Dashboard,
    path: PATHS.WINS_DASHBOARD.INDEX.value,
  },
  {
    title: 'Reports',
    description: 'View analytical reports',
    icon: Summarize,
    path: PATHS.REPORTS.INDEX.value,
  },
  {
    title: 'Experts',
    description: 'Manage experts',
    icon: PeopleAlt,
    path: PATHS.EXPERT.value,
  },
  {
    title: 'Outlets',
    description: 'Manage media outlets',
    icon: Newspaper,
    path: PATHS.MANAGE_OUTLETS.value,
  },
  {
    title: 'Keywords',
    description: 'Manage keywords',
    icon: Tag,
    path: PATHS.MANAGE_KEYWORDS.value,
  },
];

export default toolsItems;
